import { render, staticRenderFns } from "./TeamPersonDay.vue?vue&type=template&id=7541307f"
import script from "./TeamPersonDay.vue?vue&type=script&lang=js"
export * from "./TeamPersonDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports